import { render, staticRenderFns } from "./EmailNotifications.vue?vue&type=template&id=1ab3a987&scoped=true"
import script from "./EmailNotifications.vue?vue&type=script&lang=js"
export * from "./EmailNotifications.vue?vue&type=script&lang=js"
import style0 from "./EmailNotifications.vue?vue&type=style&index=0&id=1ab3a987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3a987",
  null
  
)

export default component.exports